import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface QuestionComment {
  body: string;
  controversy: number;
  createdOn: Date;
  id: number;
  replyCount: number;
  sentimentScore: number;
}

interface CommentsSlice {
  isLoading: boolean;
  questionsReactedComments: QuestionComment[];
  error: string;
}

const initialState: CommentsSlice = {
  isLoading: false,
  questionsReactedComments: [],
  error: "",
};

export const getReactedQuestionsComments = createAsyncThunk(
  "getReactedControversialQuestions",
  async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/reports/boards/${id}/reaction/controversial-questions`
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const reactedQuetsionsSlice = createSlice({
  initialState,
  name: "board",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReactedQuestionsComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReactedQuestionsComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.questionsReactedComments = action.payload;
      })
      .addCase(getReactedQuestionsComments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
